import React, { Children } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './Tag.themes';
export type Props = {
  children: React.ReactNode;
  className?: string;
  iconName?: IconName;
  theme?: keyof typeof themes;
};
export const Tag = ({ children, className, iconName, theme = 'default', ...rest }: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  const { thRoot } = themes[theme];
  return (
    <span {...rest} className={classnames(thRoot, className)}>
      <Icon className="shrink-0" name={iconName} width="1em" />
      {children}
    </span>
  );
};
